export default __webpack_public_path__ + "static/media/raleway-bold.d1a96e2a.ttf";